import angular from 'angular';
import tabs from './tabs';
import flipper from './flipper';
export default angular.module('app.ui', [
  tabs,
  flipper
]).name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/ui/index.js
 **/